import type { RootState } from 'store'

export const getPage = (state: RootState) => state?.myWines?.pageInfo?.page
export const getItems = (state: RootState) => state?.myWines?.items || []
export const getSelectedItems = (state: RootState) =>
  state?.myWines?.selectedItems || []
export const getPageInfo = (state: RootState) => state?.myWines?.pageInfo ?? {}
export const getUpdatingItems = (state: RootState) =>
  state?.myWines?.updatingItems ?? []
